import React from 'react';
import WithPermission from 'hocs/WithPermission';
import PropTypes from 'prop-types';

import Loader from '../Loader/Loader';

import classNames from '../../utils/classNames';

import styles from './button.scss';

function Button(props) {
    const { disabled, danger, loading, size, fill, level, onClick, icon, text, tabIndex } = props;

    function handleClick(e) {
        if (typeof onClick === 'function') {
            if (!disabled && !loading) onClick(e);
        }
    }
    const classes = classNames(styles.button, {
        [styles.secondary]: level === 'secondary',
        [styles.tertiary]: level === 'tertiary',
        [styles.disabled]: disabled,
        [styles.danger]: danger,
        [styles.loading]: loading,
        [styles.small]: size === 's',
        [styles.fill]: fill,
    });

    return (
        <div className={classes} tabIndex={tabIndex} onClick={handleClick}>
            {props.icon !== undefined && <div className={styles.icon}>{icon}</div>}
            {loading && (
                <div className={styles.loader}>
                    <Loader dark={level === 'secondary' || level === 'tertiary'} />
                </div>
            )}
            <span>{text}</span>
        </div>
    );
}

Button.propTypes = {
    disabled: PropTypes.bool,
    danger: PropTypes.bool,
    icon: PropTypes.element,
    /**
     * Button level: primary, secondary, tertiary.
     *
     * Default is "primary".
     */
    level: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    onClick: PropTypes.func,
    size: PropTypes.oneOf(['m', 's']),
    /**
     * Button's label.
     */
    text: PropTypes.string.isRequired,
    fill: PropTypes.bool,
    loading: PropTypes.bool,
    tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Button.defaultProps = {
    disabled: false,
    level: 'primary',
    size: 'm',
};

export default WithPermission(Button);
